/**
 * A simple toggle switch component.
 */
import * as preact from "preact";
import { useState } from "preact/hooks";

interface Props {
  stateOne: string;
  stateTwo: string;
  onToggle?: (selected: string) => void;
}

const ToggleSwitch: preact.FunctionalComponent<Props> = ({
  stateOne,
  stateTwo,
  onToggle,
}) => {
  const [selected, setSelected] = useState(stateTwo);

  const handleToggle = async () => {
    const newValue = selected === stateOne ? stateTwo : stateOne;
    setSelected(() => newValue);
    onToggle?.(newValue);
  };

  return (
    <div className="toggle-switch" onClick={handleToggle}>
      <div
        className={`toggle-pill ${selected === stateOne ? "left" : "right"}`}
      ></div>
      <div
        className={`toggle-option ${selected === stateOne ? "selected" : ""}`}
      >
        {stateOne}
      </div>
      <div
        className={`toggle-option ${selected === stateTwo ? "selected" : ""}`}
      >
        {stateTwo}
      </div>
    </div>
  );
};

export default ToggleSwitch;
